<div class="text-xl font-bold mb-8 px-4 mt-4 text-(--mat-sys-on-surface)">HLSS</div>
<mat-nav-list class="px-2">
  @for (item of menus(); track item.route) {
    <a mat-list-item 
       [routerLink]="item.route" 
       routerLinkActive="bg-primary-container text-on-primary-container rounded-lg font-bold"
       [routerLinkActiveOptions]="{exact: item.route === '/dashboard'}"
       class="mb-1">
      <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
      <span matListItemTitle>{{ item.label }}</span>
    </a>
  }
</mat-nav-list>
